import Component from '../app/component'

export default class MapComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
    }
  }

  init () {
    if (this.refs?.pins?.length) {
      this.refs.pins.forEach((el) => {
        el.addEventListener('pointerdown', () => {
          console.log(el.dataset)
          const nmbr = el.dataset.number
          const targetEl = document.querySelector(`.mapitems-item--${nmbr}`)
          if (targetEl) {
            const topHeight = document.querySelector('.top').offsetHeight
            const top = targetEl.getBoundingClientRect().top + window.scrollY - topHeight
            window.scrollTo({
              top,
              behavior: 'smooth'
            })
          }
        })
      })
    }
  }
}
